<template>
	<div class="wrapper">
		<sub-ibox-title :is-show-back=true>
			<p slot="title">{{params.id ? '编辑' : '新增'}}商品</p>
		</sub-ibox-title>
		<section class="content">
			<div class="detail-cont">
				<z-input title="商品名称" v-model="params.name" :isMust=true></z-input>
				<div class="fx m-t-20">
					<div class="title fx w120 m-r-5"><p class="ask-cont"><i class="ask">*</i></p><span class="fx-fill">商品封面</span></div>
					<!--<z-up-file :listArr="picList"></z-up-file>-->
					<z-upload :file-url='params.face' :on-success="handleFaceSuccess"></z-upload>
				</div>
				<div class="fx m-t-5"><p class="w120 m-r-5"></p><div class="pic-tips">建议尺寸：640*600；文件大小建议300KB以内</div></div>
				<div class="fx m-t-20">
					<div class="title fx w120 m-r-5"><p class="ask-cont"></p><span class="fx-fill">商品图集</span></div>
					<!--<z-up-file :listArr="picLists" :fileNum="5"></z-up-file>-->
					<z-upload :file-num =5 :file-list = 'params.album_list' :on-success="handleAlbumSuccess"></z-upload>
				</div>
				<div class="fx m-t-5"><p class="w120 m-r-5"></p><div class="pic-tips">建议尺寸：640*600；文件大小建议300KB以内；最多五张图片</div></div>
				<z-select title="所属分类" :options="typeList" v-model="params.goods_type_id" class="m-t-20" :isMust=true></z-select>
				<z-input title="商品原价" class="m-t-20" v-model="params.list_price" :isMust=true type="number"></z-input>
				<z-input title="商品售价" class="m-t-20" v-model="params.price" :isMust=true></z-input>
				<div class="fx m-t-20">
					<div class="title fx w120 m-r-5 m-t-10"><p class="ask-cont"></p><span class="fx-fill">规格属性</span></div>
					<div>
						<div>
							<!--<z-input title="属性名" v-model="params.standard.title"></z-input>-->
							<span>属性名</span>
							<input class="input b-r-3 input-width m-l-10" type="text" placeholder="如：颜色（只能有一个）" v-model="params.standard.title" maxlength=15/>
						</div>
						<div class="fx m-t-5"><div class="pic-tips fx-fill">Tips：属性名最多15个字符</div></div>
						<div class="m-t-10">
							<!--<z-input title="属性值" class="m-t-10" @handleBlur="handleBlur()" @handleKeyEnter="handleBlur()" v-model="standardValue"></z-input>-->
							<span>属性值</span>
							<input class="input b-r-3 input-width m-l-10" type="text" placeholder="如：红色、黑色（可有多个）" v-model="standardValue" @keyup.enter="handleBlur()" v-on:blur="handleBlur()" maxlength=10 />
						</div>
						<div class="key-list">
							<ol class="fx fx-wrap">
								<li v-for="(item,index) in params.standard.items || []">
									{{item}}
									<em class="icon-del" @click="handleDelInputStandard(index)"></em>
								</li>
							</ol>
						</div>
					</div>
				</div>
				<div class="fx m-t-5"><p class="w120 m-r-5 fx-shrink"></p><div class="pic-tips fx-fill">Tips：属性值最多10个字符。（输入完成后按回车即可完成添加）</div></div>
				<div class="fx fx-y-center m-t-20">
					<p class="title fx fx-shrink w120 m-r-5"><i class="ask">*</i><span class="fx-fill">商品详情</span></p>
					<p class="fx-fill edit-cont">
						<div id="content" placeholder="请在这里输入内容"></div>
					</p>
				</div>
				<!--<div class="fx fx-y-center m-t-20">
					<p class="title fx w120 m-r-5"><span class="fx-fill">首页推荐</span></p>
					<div>
						<mt-switch v-model="params.recommend" @change="handleSetRecommend(params.recommend ? true : false)">{{params.recommend ? '是' : '否' }}</mt-switch>
					</div>
				</div>-->
			</div>
			<!--<p class="p-t-20">
				<span><a class="z-btn z-btn-primary b-r-5" @click="handleValidation()">保存</a></span>
			</p>-->
			<div class="m-t-30 fx">
				<p class="w120 m-r-5 fx-shrink"></p>
				<a class="z-btn z-btn-primary b-r-3" @click="handleValidation()">保存</a>
			</div>
		</section>
	</div>
</template>
<script>
	import { mapActions, mapState } from 'vuex'
	export default {
		name: 'GoodsEdit',
		components: {},
		data() {
			return {
				params: {
					id: null,
					name: '',
					goods_type_id: 1,
					list_price: '',
					price: '',
					face: '',
					content: '',
					recommend: true,
					album_list: [],
					standard: {
						title: '',
						items: []
					},
				},
				typeList: [],
				standardValue: null,
				picList: [],
				picLists: [],
				editor:null
			}
		},
		mounted() {
			this.editor = this.$editorInit('#content')
			this.params.id = this.$route.query.id || null
			this.handleGetGoodsTypeList()
			if(this.$re_Number(this.params.id)) this.handleGetGoodsDetail();
			
			
		},
		methods: {
			//上传封面
			handleFaceSuccess(url){
				this.params.face = url
			},
			//上传图集
			handleAlbumSuccess(url){
				this.params.album_list.push(url)
			},
			//删除属性值
			handleDelInputStandard(index) {
				(this.params.standard.items).splice(index, 1);
			},

			//设置属性值
			handleBlur() {
				if(!this.standardValue) {
					return;
				}
				(this.params.standard.items).push(event.target.value);
				this.standardValue = null;
			},
			//提交验证...
			handleValidation() {
				if(!this.params.name) return this.$warning('商品名称必须填写...');
				if(!this.params.face) return this.$warning('商品封面必须上传...');
				
				if ( (this.params.standard.title && this.params.standard.items.length <= 0) || (!this.params.standard.title && this.params.standard.items.length > 0)) {
					return this.$warning('请输入合法的商品规格属性...');
				}
				
				if (!this.$re_twoPoint(this.params.list_price)) return this.$warning('请输入正确的原价金额...')
				if (!this.$re_twoPoint(this.params.price)) return this.$warning('请输入正确的售价金额...')
				if (parseFloat(this.params.list_price) < parseFloat(this.params.price)) return this.$warning('原价不能小于售价...');
				
				this.params.list_price = (this.params.list_price) * 100;//市场价
				this.params.price = (this.params.price) * 100;//售价
				this.params.standard = this.params.standard; //规格属性
//				this.params.content = this.editor.txt.html();
				//将所有的img标签新增class为img-responsive
				let contentHtml = this.editor.txt.html();
				contentHtml = this.formatImg(contentHtml);
				this.params.content = contentHtml;
				//保存操作
				this.handleSave();
			},
			
			//给字符串中所有img标签新增class为img-responsive
			formatImg(html) {
	            	var newContent= html.replace(/<img[^>]*>/gi, function(match,capture) {
		          	var match = match.replace(/style=\"(.*)\"/gi, 'class="img-responsive"');
		            return match;
		        });  
		        return newContent;  
	   		},

			//保存
			async handleSave() {
				try{
					await this.saveGoods(this.params)
					this.$success('保存成功');
					this.$back();
				}catch(e){
					this.$errorMsg('保存失败')
				}
			},

			//获取商品详情
			async handleGetGoodsDetail() {
				try{
					const data = await this.getGoodsDetail(this.params)
					data.list_price = data.list_price ? data.list_price/100: ''
					data.price = data.price ? data.price/100: ''
					this.params = data
					this.editor.txt.html(data.content);
				}catch(e){
					this.$errorMsg('获取商品详情失败')
				}
			},

			//获取商品分类
			async handleGetGoodsTypeList() {
				let data = await this.getGoodsTypeList({offset:0,count:100})
				this.typeList =[{
						value: 1,
						text: '系统分类'
					},...data];
			},
			 
			...mapActions(['saveGoods', 'getGoodsDetail', 'getGoodsTypeList']),
		},
	}
</script>
<style lang="scss" scoped>
	@import "src/assets/css/common.scss";
	#content {
		min-height: px-em(400px);
	}
	 .content{
    	border-top: none;
    }
	.detail-cont {
		width: 600px;
		.input-width{
			width: px-em(400px) !important;
		}
		.pic-cont {
			position: relative;
			width: px-em(120px);
			height: px-em(120px);
			border: 1px solid $color-border;
			cursor: pointer;
			overflow: hidden;
			&:hover {
				.edit {
					opacity: 1;
				}
			}
			input {
				display: inline-block;
				width: px-em(120px);
				height: px-em(120px);
				opacity: 0;
				position: relative;
				z-index: 99;
				cursor: pointer;
			}
			img {
				width: 100%;
				height: 100%;
				position: absolute;
				top: 0;
				left: 0;
			}
			.edit {
				opacity: 0;
				position: absolute;
				top: 0;
				left: 0;
				bottom: 0;
				right: 0;
				width: 100%;
				height: 100%;
				background: rgba(0, 0, 0, 0.3);
				transition: all 0.2s ease;
				.icon {
					transition: all 0.2s ease;
					color: #fff;
					font-size: px-em(32px);
				}
			}
		}
	}
	
	.file-btn {
		position: relative;
		width: px-em(200px);
		height: px-em(50px);
		overflow: hidden;
		cursor: pointer;
		&:hover {
			a {
				opacity: 0.8;
			}
		}
		a {
			position: absolute;
			width: 100%;
			height: 100%;
			z-index: 0;
		}
		input {
			position: absolute;
			display: block;
			opacity: 0;
			z-index: 1;
			width: 100%;
			height: 100%;
			cursor: pointer;
		}
	}
	.edit-cont{
		width: 700px;
	}
	.key-list {
		/*		padding: 0 px-em(100px);*/
		li {
			margin-right: px-em(20px);
			margin-top: 10px;
			background: $color-e5e7ec;
			padding: 3px 10px;
			position: relative;
			cursor: pointer;
			em {
				position: absolute;
				width: 20px;
				height: 20px;
				right: -10px;
				top: -10px;
				color: $color-main;
				font-size: 20px;
				z-index: 2;
				display: none;
				cursor: pointer;
			}
			&:hover {
				em {
					display: block;
				}
			}
		}
	}
	@media only screen and (min-width:0px) and (max-width:640px) {
		.wrapper{
			min-width: px-em(1400px);
		}	
		.edit-cont{
			width: px-em(1000px) !important;
		}
	}
</style>


// WEBPACK FOOTER //
// GoodsEdit.vue?cee57d5e